import { useState } from "react";
import { DefaultButton } from "../../../components/widgets";
import { TrackOverlayModal } from "../modals/track-overlay";
import { TrackResultModal } from "../modals/track-result";
import { useDispatch } from "react-redux";

const Tracks = (props: any) => {
  let { idsexist, addExistingTrack } = props;
  const [showModal, setShowModal] = useState<any>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [showSecondModal, setShowSecondModal] = useState<boolean>(false);
  const [formData, setFormData] = useState<any>({});
  const [data, setData] = useState<any>({});
  const [selectedRelease, setSelectedRelease] = useState("");
  const [selectedTrackTitle, setSelectedTrackTitle] = useState("");
  const dispatch = useDispatch();
  const [abortController, setAbortController] =
    useState<AbortController | null>(null);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = () => {
    dispatch({
      type: "SET_SELECT_TRACKS",
      payload: [],
    });
    dispatch({ type: "SET_TRACK_LIST", payload: [] });
    setShowModal(true);
    setData({});
    setSelectedRelease("");
    setSelectedTrackTitle("");
  };

  const closeSecondModal = () => {
    if (abortController) {
      abortController.abort();
    }
    setShowSecondModal(false);
  };

  const handleTrackOverlaySaveAction = () => {
    console.log("test");
  };

  const handlerBack = () => {
    if (abortController) {
      abortController.abort();
    }
    setShowSecondModal(false);
    setShowModal(true);
    dispatch({
      type: "SET_SELECT_TRACKS",
      payload: [],
    });
    dispatch({ type: "SET_TRACK_LIST", payload: [] });
  };

  return (
    <div className=" page-label mb-5">
      <DefaultButton onClick={handleOpenModal}>
        Choose existing track
      </DefaultButton>
      <TrackOverlayModal
        mkey={"track-overlay-info"}
        show={showModal}
        closeModal={handleCloseModal}
        saveModal={handleTrackOverlaySaveAction}
        openSecondModal={() => setShowSecondModal(true)}
        setFormData={setFormData}
        setLoading={setLoading}
        setData={setData}
        data={data}
        setAbortController={setAbortController}
        selectedRelease={selectedRelease}
        setSelectedRelease={setSelectedRelease}
        selectedTrackTitle={selectedTrackTitle}
        setSelectedTrackTitle={setSelectedTrackTitle}
      />
      <TrackResultModal
        mkey={"track-result-info"}
        show={showSecondModal}
        closeModal={closeSecondModal}
        handlerBack={handlerBack}
        saveModal={handleTrackOverlaySaveAction}
        formData={formData}
        idsexist={idsexist}
        addExistingTrack={addExistingTrack}
        loading={loading}
        setData={setData}
      />
    </div>
  );
};

export default Tracks;
